// src/utils/validators/ugc/ugcPolicies.ts

import type { ImagePolicy, VideoPolicy } from "./mediaValidator";

/**
 * Central UGC upload policies.
 * Original media may be optimized after upload.
 */

/* -----------------------------
   Shared
----------------------------- */

export const DEFAULT_IMAGE_MIME_PREFIX = "image/";
export const DEFAULT_VIDEO_MIME_PREFIX = "video/";

// Original video upload allowance.
export const UGC_UPLOAD_MB_PER_MINUTE = 200;

/* -----------------------------
   Moments
----------------------------- */

export const MOMENT_IMAGE_POLICY: ImagePolicy = {
  maxMB: 20,
  mimePrefix: DEFAULT_IMAGE_MIME_PREFIX,
};

export const MOMENT_VIDEO_POLICY: VideoPolicy = {
  minDurationSec: 15,
  maxDurationSec: 300,

  // Up to 5 × 200MB.
  capMB: 1000,
  mbPerMinute: UGC_UPLOAD_MB_PER_MINUTE,

  mimePrefix: DEFAULT_VIDEO_MIME_PREFIX,
};

/* -----------------------------
   Prayers
----------------------------- */

export const PRAYER_IMAGE_POLICY: ImagePolicy = {
  maxMB: 20,
  mimePrefix: DEFAULT_IMAGE_MIME_PREFIX,
};

export const PRAYER_VIDEO_POLICY: VideoPolicy = {
  minDurationSec: 30,
  maxDurationSec: 300,

  // Up to 5 × 200MB.
  capMB: 1000,
  mbPerMinute: UGC_UPLOAD_MB_PER_MINUTE,

  mimePrefix: DEFAULT_VIDEO_MIME_PREFIX,
};

/* -----------------------------
   Testimonies
----------------------------- */

export const TESTIMONY_IMAGE_POLICY: ImagePolicy = {
  maxMB: 20,
  mimePrefix: DEFAULT_IMAGE_MIME_PREFIX,
};

export const TESTIMONY_VIDEO_POLICY: VideoPolicy = {
  minDurationSec: 120,
  maxDurationSec: 600,

  // Up to 10 × 200MB.
  capMB: 2000,
  mbPerMinute: UGC_UPLOAD_MB_PER_MINUTE,

  mimePrefix: DEFAULT_VIDEO_MIME_PREFIX,
};

/* -----------------------------
   Helpers
----------------------------- */

export type UGCPolicyKey = "moment" | "testimony" | "prayer";

export function getUGCImagePolicy(
  key: UGCPolicyKey
): ImagePolicy {
  switch (key) {
    case "moment":
      return MOMENT_IMAGE_POLICY;

    case "prayer":
      return PRAYER_IMAGE_POLICY;

    case "testimony":
      return TESTIMONY_IMAGE_POLICY;
  }
}

export function getUGCVideoPolicy(
  key: UGCPolicyKey
): VideoPolicy {
  switch (key) {
    case "moment":
      return MOMENT_VIDEO_POLICY;

    case "prayer":
      return PRAYER_VIDEO_POLICY;

    case "testimony":
      return TESTIMONY_VIDEO_POLICY;
  }
}